export const FlowDopplerFields = [
  "Tricuspid",
  "Mitral",
  "Aortic",
  "Pulmonic",
  "PAT= NV > 100ms",
  // { title: "Tricuspid", range: "(m/s)" },
  // { title: "Tricuspid Peak Gradient", range: "(mmHg)" },
  // { title: "Tricuspid Mean Gradient", range: "(mmHg)" },
  // { title: "Tricuspid VTI", range: "(cm)" },

  // { title: "Mitral Vmax", range: "(m/s)" },
  // { title: "Mitral Peak Gradient", range: "(mmHg)" },
  // { title: "Mitral Mean Gradient", range: "(mmHg)" },
  // { title: "Mitral VTI", range: "(cm)" },

  // { title: "Aortic Vmax", range: "(m/s)" },
  // { title: "Aortic Peak Gradient", range: "(mmHg)" },
  // { title: "Aortic Mean Gradient", range: "(mmHg)" },
  // { title: "Aortic VTI", range: "(cm)" },

  // { title: "Pulmonic Vmax", range: "(m/s)" },
  // { title: "Pulmonic Peak Gradient", range: "(mmHg)" },
  // { title: "Pulmonic Mean Gradient", range: "(mmHg)" },
  // { title: "Pulmonic VTI", range: "(cm)" },
];
export default FlowDopplerFields;
